import { type DocumentType } from "@/gql";
import { toast } from "@/lib/toast";

import type { CURRENT_USER_UPDATES_SUBSCRIPTION } from "../graphql/current-user-updates-subscription";

export function currentUserUpdatesResolver(
  result: DocumentType<typeof CURRENT_USER_UPDATES_SUBSCRIPTION>,
) {
  if (!result?.currentUserUpdates?.user) {
    // no user on object, do nothing
    return;
  }

  const event = result.currentUserUpdates.event ?? "updated";
  // const userId = result.currentUserUpdates.user.id;

  if (event === "membership_added") {
    toast.success("Organization Joined!");
  }
}
